/*
  Premium Deals-tab in het menu: blijft als lipje aan de bovenrand van het scherm hangen zodra de kop
  bij naar beneden scrollen uit beeld gaat, en zakt terug in de kop als die weer verschijnt.
  Alleen desktop (>= 990px); op mobiel zit het label in het menu zelf.
*/
(function () {
  var tab = document.querySelector('a.sf-menu-pd-tab');
  var header = document.querySelector('.header-wrapper');
  if (!tab || !header || !('IntersectionObserver' in window)) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var left = 0;

  function measure() {
    if (!tab.classList.contains('is-pinned')) {
      left = tab.getBoundingClientRect().left;
    }
    tab.style.setProperty('--sf-pd-tab-left', left + 'px');
  }

  var home = document.createComment('sf-menu-pd-tab');
  tab.parentNode.insertBefore(home, tab);

  // Houdt de plek van de pil bezet zolang die in <body> hangt, anders krimpt de kop en gaat de
  // sticky kop heen en weer flippen (de hoogteverandering telt mee als scroll in tegengestelde richting).
  var ghost = document.createElement('span');
  ghost.setAttribute('aria-hidden', 'true');
  ghost.style.cssText = 'display:block;visibility:hidden;pointer-events:none;flex:none;align-self:stretch;';

  function update(visible) {
    measure();
    var pin = !visible && desktop.matches;
    if (pin && !tab.classList.contains('is-pinned')) {
      // De kop is met een transform weggeschoven; fixed werkt daarbinnen niet. Daarom tijdelijk naar <body>.
      var r = tab.getBoundingClientRect();
      ghost.style.width = r.width + 6 + 'px';
      ghost.style.height = r.height + 'px';
      home.parentNode.insertBefore(ghost, home.nextSibling);
      document.body.appendChild(tab);
      tab.classList.add('is-pinned');
    } else if (!pin && tab.classList.contains('is-pinned')) {
      tab.classList.remove('is-pinned');
      home.parentNode.insertBefore(tab, home.nextSibling);
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
    }
  }

  var headerVisible = true;
  var observer = new IntersectionObserver(
    function (entries) {
      headerVisible = entries[0].isIntersecting;
      update(headerVisible);
    },
    { rootMargin: '-2px 0px 0px 0px', threshold: 0 }
  );
  observer.observe(header);

  window.addEventListener('resize', function () {
    update(headerVisible);
  });
  measure();
})();
